import React from "react";
import styles from "../../pages/styles";

const skills = [
  "Game Design",
  "Computer Basics",
  "3D Modelling",
  "2D Digital Art",
  "Computer Building",
  "Animation",
  "Programming",
  "Video Editing",
  "Website Development",
  "Microsoft Office",
  "Storytelling",
  "Graphic Design",
  "App Development",
  "Sound Design",
  "Creative Writing",
];

const NavigatorSkills = () => {
  return (
    <div className="mx-auto py-8 md:py-10 px-4 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto mb-6 md:mb-8">
          <h2 className={`${styles.biggerheadingdark} mb-3 md:mb-4`}>
            Skills We Teach
          </h2>
          <p className={`${styles.paragraph}`}>
            Learn practical tech skills that prepare you for jobs in technology, design, and digital media
          </p>
        </div>
        <div className="flex flex-wrap gap-4 justify-center max-w-5xl mx-auto">
          {skills.map((skill, index) => (
            <Bubble key={index} text={skill} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Bubble = ({ text }) => {
  const style = {
    "--animation-duration-y": `${4 + Math.random() * 3}s`,
    "--translate-y": `${3 + Math.random() * 20}px`,
  };

  return (
    <div
      className="bubble bg-orangeprimary/90 hover:bg-orangeprimary rounded-full py-2.5 px-5 text-center shadow-sm hover:shadow-md transition-all border-2 border-orangeprimary"
      style={style}
    >
      <p className={`${styles.paragraph} text-md mb-0 font-medium`}>{text}</p>
    </div>
  );
};

export default NavigatorSkills;
